import { createReducer, on } from '@ngrx/store';

import { CounterpartyList, ErrorMessage } from '@shared/models';

import { CounterpartyActions } from './counterparty.actions';

export const counterpartyListFeatureKey = 'list';

export interface CounterpartyState {
  counterparties: CounterpartyList['items'] | null;
  totalElements: number;
  isLoading: boolean;
  error: ErrorMessage;
}

export const initialCounterpartyState: CounterpartyState = {
  counterparties: null,
  totalElements: 0,
  isLoading: false,
  error: null,
};

export const reducer = createReducer<CounterpartyState>(
  initialCounterpartyState,
  on(CounterpartyActions.loadCounterparties, (state): CounterpartyState => {
    return {
      ...state,
      isLoading: true,
      error: null,
    };
  }),
  on(CounterpartyActions.loadCounterpartySuccess, (state, action): CounterpartyState => {
    return {
      ...state,
      counterparties: action.counterparties,
      totalElements: action.totalElements,
      isLoading: false,
    };
  }),
  on(CounterpartyActions.loadCounterpartyError, (state, action): CounterpartyState => {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  }),
);

export const getCounterparty = (state: CounterpartyState) => state?.counterparties;
export const getTotalElements = (state: CounterpartyState) => state?.totalElements;
export const getLoading = (state: CounterpartyState) => state?.isLoading;
